var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.10712 4.9233C7.36149 1.56723 12.6379 1.56723 15.8922 4.9233C17.0444 6.11143 17.7897 7.56324 18.1258 9.0911C18.2277 9.55395 17.9464 10.0143 17.4975 10.1193C17.0487 10.2243 16.6023 9.93426 16.5005 9.4714C16.2319 8.25049 15.637 7.09082 14.7137 6.13864C12.1102 3.45379 7.88913 3.45379 5.28563 6.13864C4.30365 7.1513 3.6549 7.8917 3.22825 8.42188H6.66634C7.12658 8.42188 7.49967 8.80663 7.49967 9.28125C7.49967 9.75587 7.12658 10.1406 6.66634 10.1406H1.66634C1.2061 10.1406 0.833008 9.75587 0.833008 9.28125V4.125C0.833008 3.65038 1.2061 3.26563 1.66634 3.26563C2.12658 3.26563 2.49967 3.65038 2.49967 4.125V6.66324C2.91613 6.18328 3.44213 5.60908 4.10712 4.9233ZM2.50181 11.8807C2.95064 11.7757 3.39704 12.0657 3.49888 12.5286C3.7675 13.7495 4.3623 14.9092 5.28563 15.8614C7.88913 18.5462 12.1102 18.5462 14.7137 15.8614C15.6957 14.8487 16.3444 14.1083 16.7711 13.5781H13.333C12.8728 13.5781 12.4997 13.1934 12.4997 12.7188C12.4997 12.2441 12.8728 11.8594 13.333 11.8594H18.333C18.7932 11.8594 19.1663 12.2441 19.1663 12.7188V17.875C19.1663 18.3496 18.7932 18.7344 18.333 18.7344C17.8728 18.7344 17.4997 18.3496 17.4997 17.875V15.3368C17.0832 15.8167 16.5572 16.3909 15.8922 17.0767C12.6379 20.4328 7.36149 20.4328 4.10712 17.0767C2.95499 15.8886 2.20968 14.4368 1.87352 12.9089C1.77168 12.446 2.05298 11.9857 2.50181 11.8807Z",
    fill: "#0157FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.c579e436617c37a00b5cb59149973326.svg";
export { ForwardRef as ReactComponent };